import { memo } from "react";

type IconProps = {
  width?: number;
  height?: number;
  className?: string;
};

export const ReplyIcon: React.FC<IconProps> = memo(
  ({ width = 48, height = 48, className }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M41 7.5L41.1006 7.50977C41.3286 7.55629 41.5 7.75829 41.5 8V32.1689C41.5 32.4451 41.2761 32.6689 41 32.6689H34.9004V41C34.9004 41.2066 34.7729 41.3924 34.5801 41.4668C34.3873 41.5412 34.1681 41.4889 34.0293 41.3359L26.1641 32.6689H8C7.72386 32.6689 7.5 32.4451 7.5 32.1689V8L7.50977 7.89941C7.55629 7.67145 7.75829 7.5 8 7.5H41Z"
        fill="#479EEA"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14H37M12 20.2069H18.7308M24.9808 20.2069H37M12 26H37"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
);
